import StoreUtil from '@/store/StoreUtil'

export default {
  SET_ERROR: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.meta, 'setError'),
  SET_COUNTRIES: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.meta,
    'setCountries'
  ),
  SET_REGIONS: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.meta,
    'setRegions'
  ),
  SET_CLIENT_COUNTRY: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.meta,
    'setClientCountry'
  ),
  SET_PRINT_MODE: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.meta,
    'setPrintMode'
  ),
}
